module.exports = __webpack_public_path__ + "img/Step2.4edb8984.png";